import Axios from 'axios';
import router from '../router'

/**
 * [{
  @param {string} url 需要缓存的URL
  @param {number} count 缓存次数
}]

 */
const catach_url = [] //缓存数据的url地址

const catchData = {}

const service = Axios.create({
  baseURL: '', //是用于请求的服务器 URL
  timeout: 0, // 请求超时时间 如果请求话费了超过 `timeout` 的时间，请求将被中断
  headers: { 'X-Custom-Header': 'foobar' } // 自定义请求头
});

service.interceptors.request.use(function (config) {
  return config;
}, function (error) {

  return Promise.reject(error);
});

service.interceptors.response.use(function (response) {
  // 对未登录进行判断
  let data = response.data
  if (data.code == 600) {
    router.push("/login")
  }

  if (catach_url.some(item => {
    return item.url == response.config.url
  })) {
    catchData[response.config.url] = response
  }

  return response;
}, function (error) {
  // 对响应错误做点什么

  return Promise.reject(error);
});


//获取缓存数据的函数
function httpCache(config) {
  let currentIndex = null;
  const cache = catach_url.filter((item, index) => {
    if (item.url == config.url) {
      currentIndex = index
      return true
    } else {
      return false
    }
  })


  // 无配置直接返回
  if (!cache[0]) { return service(config) }

  const catach_url_conf = cache && cache[0]

  //备份请求次数
  if (!catach_url_conf.back_count) {
    catach_url_conf.back_count = catach_url_conf.count
  }

  if (config.url && catach_url_conf.url == config.url && catchData[config.url]) {
    // 每次请求，请求次数减去1
    if (catach_url_conf.count == -1) {
      catach_url_conf.count == catach_url_conf.back_count
      return service(config)
    }
    catach_url_conf.count -= 1

    //刷新存储的数据

    catach_url.splice(1, currentIndex, catach_url_conf)
    // 返回缓存的数据
    return Promise.resolve(catchData[config.url])
  } else {
    return service(config)
  }
}

export { catach_url, catchData, httpCache }
export default service


// WEBPACK FOOTER //
// ./src/api/index.js